export default __webpack_public_path__ + "static/media/file_unknown_icon.aca10432.png";